import React, { useEffect, useState } from 'react';
import moment from 'moment';
import LineChart from '../../components/Charts/LineChart';
import BarChart from '../../components/Charts/BarChart';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { api, endpoint } from '../../api';
import { useSelector } from 'react-redux';

const startOfMonth = moment().startOf('month').format("YYYY-DD-MM");
const endOfMonth = moment().endOf("month").format("YYYY-DD-MM");

const UserDashboard = () => {
    const userDetails = useSelector((state) => state?.user?.userDetails);

    const [userData, setUserData] = useState()

    const getUserDetailData = async (id) => {
        const data = await api.get(endpoint.get_UserDashboard + '/' + id)
        console.log({data})
    }
    const getUserDashboardChart = async (id) => {
        const data = await api.get(endpoint.get_UserDashboardChart + '/' + id, {
            params: {
                type: 'daily'
            }
        })
        console.log({data})
    }

    useEffect(() => {
        if (userDetails?._id)
            // getUserDetailData(userDetails._id)
            getUserDashboardChart(userDetails._id)
    }, [userDetails._id])

    const chartData = [
        {
            "x": "2023-03-02T20:00:00.000Z",
            "y": 476
        },
        {
            "x": "2023-03-08T18:00:00.000Z",
            "y": 398880
        },
        {
            "x": "2023-03-08T19:00:00.000Z",
            "y": 236920
        },
        {
            "x": "2023-03-08T20:00:00.000Z",
            "y": 272324
        },
        {
            "x": "2023-03-08T21:00:00.000Z",
            "y": 288480
        },
        {
            "x": "2023-03-09T02:00:00.000Z",
            "y": 362376
        },
        {
            "x": "2023-03-09T07:00:00.000Z",
            "y": 193200
        },
        {
            "x": "2023-03-09T08:00:00.000Z",
            "y": 299628
        },
        {
            "x": "2023-03-09T09:00:00.000Z",
            "y": 149700
        },
        {
            "x": "2023-03-09T10:00:00.000Z",
            "y": 198072
        },
        {
            "x": "2023-03-09T11:00:00.000Z",
            "y": 228330
        },
        {
            "x": "2023-03-09T12:00:00.000Z",
            "y": 218260
        },
        {
            "x": "2023-03-09T13:00:00.000Z",
            "y": 219043
        }
    ]

    const now = 60;

    return (
        <div className="az-content-body">

            <div className="row row-sm mg-b-15 mg-sm-b-20">
                <div className="col-lg-12">
                    <div className="card card-dashboard-six graphShadow">
                        <h6 className="fw-bold text-uppercase mb-4">
                            monthly energy usage overview
                        </h6>
                        <div className="row g-4  mb-4">
                            <div className="col-xxl-2 col-lg-3 col-md-6">
                                <div className="text-uppercase az-content-label  fw-bold">
                                    daily average (kwh)
                                </div>
                                <div className="fs-2 fw-bold"> 4.5 </div>
                            </div>
                            <div className="col-xxl-2 col-lg-3 col-md-6">
                                <div className="text-uppercase az-content-label  fw-bold">
                                    monthly average (kwh)
                                </div>
                                <div className="fs-2 fw-bold"> 120 </div>
                            </div>
                            <div className="col-xxl-2 col-lg-3 col-md-6">
                                <div className="text-uppercase az-content-label  fw-bold">
                                    estimated bill (rm)
                                </div>
                                <div className="fs-2 fw-bold"> 29.33 </div>
                            </div>
                            <div className="col">
                                <div className="text-uppercase az-content-label  fw-bold">
                                    About this rate
                                </div>
                                <div className="text-muted">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero similique quia autem alias illo temporibus nemo officiis unde non. Facilis quidem iure tempora fugit veritatis inventore porro cupiditate ipsum? Necessitatibus reprehenderit porro vitae quisquam!
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {/* <Spin spinning={isLoadingGraph}> */}
                            <LineChart
                                title="Parameter Comparison"
                                data={chartData}
                                from={startOfMonth}
                                to={endOfMonth}
                                type="area"
                            />
                            {/* </Spin> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row row-sm mg-b-15 mg-sm-b-20 align-items-stretch">
                <div className="col-lg-6">
                    <div className="card card-dashboard-six graphShadow">
                        <h6 className="fw-bold text-uppercase mb-4">
                            Daily energy usage (kwh)
                        </h6>
                        <div className="row" >
                            {/* <Spin spinning={isLoadingGraph}> */}
                            <BarChart
                                title="Parameter Comparison"
                                data={chartData}
                                from={startOfMonth}
                                to={endOfMonth}
                                type="area"
                                height={200}
                            />
                            {/* </Spin> */}
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card card-dashboard-six graphShadow h-100">
                        <h6 className="fw-bold text-uppercase mb-4">
                            Total payment for electricity  bill <span className='text-muted fw-normal text-capitalize'> (this year) </span>
                        </h6>
                        <div>
                            <h1 className='fw-bold'> RM 890.30 </h1>
                            <p className="text-muted"> Jan - Aug 2022 </p>

                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <h3 className='fw-bold'> RM 80.00 </h3>
                                    <div> Prepaid Credit Balance </div>
                                    <ProgressBar className='my-2' now={now} />
                                    <div className="text-muted"> {now}% of your credit top up </div>
                                </div>
                                <div className="col-md-6">
                                    <h3 className='fw-bold'> RM 130.00 </h3>
                                    <div> Maximum Credit Limit </div>
                                    <ProgressBar className='my-2' now={now} />
                                    <div className="text-muted"> {now}% of your credit top up </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default UserDashboard;